const loadModal = (page) => {
    if (page !== 'home') {
        // Aguarde até que o Elementor Pro Frontend esteja carregado
        const interval = setInterval(() => {
            if (typeof elementorProFrontend !== 'undefined' && elementorProFrontend.modules.popup) {
                elementorProFrontend.modules.popup.showPopup({ id: 250 });
                clearInterval(interval); // Pare de verificar após carregar
            }
        }, 100); // Verifica a cada 100ms
    }
};

export { loadModal };
